/**
 * Created by zhoubao on 2018/07/23.
 */
/* eslint-disable */

window.TA = function () {
  var args = Array.prototype.slice.call(arguments)
  if (window.gio) {
    window.gio.apply(null, args[0] === 'track' ? args : ['track'].concat(args));
  }
};